import { render } from "./RoiInputs.vue?vue&type=template&id=00c5b992"
import script from "./RoiInputs.vue?vue&type=script&lang=js"
export * from "./RoiInputs.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__